import {Injectable} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {VisbosService} from "../../../core/visbos-core/graphql/visbos.service";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store";
import {SessionActions} from "../../../shared/actions";
import {DepotStocktakingComponent} from "../../../store-management/stocktaking/components/depot-stocktaking-form/depot-stocktaking.component";
import {StocktakingFormComponent} from "../../../store-management/stocktaking/components/stocktaking-form/stocktaking-form.component";
import {intersectFormGroups, mergeFormGroups} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {STOCKTAKING_TYPE_MEDICINE} from "../../../store-management/stocktaking/views/init-stocktaking-view/init-stocktaking-view.component";
import {MessageType} from "../../../shared/redux-store/session";
import {StocktakingService} from "../../../store-management/services/stocktaking/stocktaking.service";
import {catchError, distinctUntilChanged, skipWhile, tap} from "rxjs/operators";
import {empty} from "rxjs/observable/empty";
import {Observable} from "rxjs/Observable";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

@Injectable()
export class TouchStocktakingService extends VisbosService {

  initStocktakingControl: FormGroup;

  latestStocktaking$: ApolloQueryObservable<any>;
  latestStocktaking;

  currentStocktakingCuid$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  currentStocktaking;

  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions,
              private fb: FormBuilder, private stocktakingService: StocktakingService) {
    super(apollo, ngRedux, sessionActions);

    this.latestStocktaking$ = this.stocktakingService.getLatestStocktaking();
    this.latestStocktaking$.subscribe(res => {
      this.latestStocktaking = res.data.latestStocktaking;
    });
    this.initMedicineStocktaking();

  }

  initMedicineStocktaking() {
    this.initGeneralStocktaking();
    mergeFormGroups(this.initStocktakingControl, DepotStocktakingComponent.initControl(this.fb));
    this.initStocktakingData();
  }

  initGeneralStocktaking() {
    if (!this.initStocktakingControl) {
      this.initStocktakingControl = StocktakingFormComponent.initControl(this.fb);
    } else {
      // Remove unused controls from group, keep only general ones
      intersectFormGroups(this.initStocktakingControl, StocktakingFormComponent.initControl(this.fb));
    }
  }

  initStocktakingData() {
    const data = {
      stocktaking_type_id: STOCKTAKING_TYPE_MEDICINE
    };
    this.initStocktakingControl.patchValue(data);
  }

  isInitialized() {
    return this.currentStocktaking != null;
  }

  reset() {
    this.initStocktakingControl = null;
    this.initMedicineStocktaking();
    this.currentStocktakingCuid$ = new BehaviorSubject<string>(null);
    this.currentStocktaking = null;
  }

  initStocktaking(data) {
    this.latestStocktaking = null;
    this.currentStocktaking = null;
    this.currentStocktakingCuid$.next(null);
    return this.stocktakingService.initMedicineStocktaking(data.depot_id, data).pipe(
      tap(res => {
        this.currentStocktakingCuid$.next(res.data.createMedicineStocktaking.cuid);
      }),
      catchError(err => {
        this.sessionActions.throwError(err);
        return err;
      })
    );
  }

  loadStocktaking(stocktakingCuid?: Observable<string>) {

    if (!stocktakingCuid) {
      stocktakingCuid = this.currentStocktakingCuid$;
    }

    stocktakingCuid = stocktakingCuid.pipe(
      skipWhile(cuid => !cuid),
      distinctUntilChanged()
    );

    return this.stocktakingService.getStocktaking(stocktakingCuid)
      .pipe(
        tap(res => {
          this.currentStocktaking = res.data.stocktaking || null;
          this.currentStocktakingCuid$.next(res.data.stocktaking.cuid);
          this.initStocktakingControl.patchValue({
            depot_id: res.data.stocktaking.depot.cuid
          })
        }),
        catchError(err => {
          this.sessionActions.throwError(err);
          return err;
        })
      );
  }

  canSealStocktaking(): boolean {
    if (!this.currentStocktaking) {
      return false;
    }
    return this.currentStocktaking.stocktaking_entries.findIndex(e => !e.pinned_down) === -1;
  }

  sealStocktaking() {

    if (!this.currentStocktaking) {
      return empty();
    }

    this.latestStocktaking = null;
    return this.stocktakingService.sealStocktaking(this.currentStocktaking.cuid).pipe(
      tap(res => {
        this.sessionActions.pushMessage("Inventur erfolgreich festgeschrieben", MessageType.SUCCESS, "Inventur");
        //this.router.navigate(['/client/lagerverwaltung']);
      }),
      catchError(err => {
        this.sessionActions.throwError(err, "Fehler beim Festschreiben der Inventur!", "Inventur");
        return err;
      })
    );

  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-stocktaking/touch-stocktaking.service.ts